export default __webpack_public_path__ + "static/media/learning.a03d6d1e.svg";